/** Exports domain query segments */
export const ExportsQueryKeys = {
  list: {
    all: ['export-list'] as const,
    page: (pageToken: unknown) => ['export-list', { page_token: pageToken }] as const,
  },
  detail: (uid: string) => [`exports/${uid}`] as const,
  download: (uid: string) => [`exports/${uid}/download`] as const,
};
